const usPhoneNumberPattern = /^\(\d{3}\) \d{3}-\d{4}$/;
const intlPhoneNumberPattern = /^\+\d[\d\s]{5,}[^\s]$/;

export const getPhoneNumberType = (phoneNumber: string) => {
  if (phoneNumber.length === 0) {
    return 0;
  }
  if (usPhoneNumberPattern.exec(phoneNumber)?.length) {
    return 1;
  }
  if (intlPhoneNumberPattern.exec(phoneNumber)?.length) {
    return 2;
  }
  return -1;
};

const phoneValidation = (phoneNumber: string): number => {
  const usPhoneNumbers = phoneNumber.match(usPhoneNumberPattern);
  const intlPhoneNumbers = phoneNumber.match(intlPhoneNumberPattern);

  if (usPhoneNumbers?.length) {
    return phoneNumber.length;
  }

  if (intlPhoneNumbers?.length) {
    return phoneNumber.length;
  }
  return 0;
};

export default phoneValidation;
